exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".maintenance-modal [class=\"Modal__Content\"] {\n  top: 20%; }\n\n.maintenance-modal__title h2 {\n  font-size: 24px !important; }\n\n.maintenance-modal__subtitle {\n  text-align: center;\n  margin-top: 10px;\n  font-size: 18px; }\n\n.maintenance-modal__button {\n  float: initial !important;\n  margin: 0 auto; }\n", ""]);

// exports
